import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toaster Component - Global toast notification container
 *
 * Configured to work with our custom Banner component for visual consistency.
 * Toasts are rendered using the BannerToast wrapper, which ensures all
 * notifications match our Ramps design system.
 *
 * @see BannerToast for the custom toast renderer
 * @see toast utilities in @/lib/toast for usage examples
 */
const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			className="toaster group"
			position="bottom-center"
			// RAMPS-4444: toasts are fixed to the viewport, so in desktop card mode
			// they would float below the card. --app-inset-y is the gap between the
			// viewport edge and the card (0 outside card mode, so this stays sonner's
			// default 24px on mobile). Set through the prop rather than CSS because
			// sonner writes these offsets inline.
			offset={{ bottom: "calc(var(--app-inset-y) + 24px)" }}
			expand={false}
			closeButton={false} // Banner component has its own close button
			richColors={false} // Using custom Banner variants instead
			toastOptions={{
				unstyled: true, // Important: We're using Banner's styles
				classNames: {
					// RAMPS-4444: match the app-wide width cap (--container-app).
					toast: "w-full max-w-app",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
